import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import api from "../../../api/api";
import Images from "../../../media/images";
import UpdatePayment from "./UpdatePayment";

const ListPayment = () => {
  const [paymentList, setPaymentList] = useState([]);
  const [paymentId, setPaymentId] = useState(null)

  useEffect(() => {
    api
      .get("info/payment-details/")
      .then((response) => {
        setPaymentList(response.data);
      })
      .catch((error) => {
        // console.log(error);
      });
  }, []);

  const handleDelete = (id) => {

    api.delete(`/info/payment-details/${id}/`)
    .then(response=> {
      toast.success("Deleted Successfully")
      let arr = paymentList.filter((item)=> item.id !== id)
      setPaymentList(arr)     
    }).catch(error=> {

    })
  }
  return (
    <div className="">
      <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
        Payment List
      </h1>
      <div className="">
        <img src={Images.title_border} alt="" className="mx-auto mt-4" />
      </div>
      <div className="px-10">
        <table className="min-w-full text-center">
          <thead className="font-Bree bg-primary-red border-b font-bold">
            <tr>
              <th
                scope="col"
                className="px-6 py-4 text-sm font-medium text-white"
              >
                SN.
              </th>
              <th
                scope="col"
                className="px-6 py-4 text-sm font-medium text-white"
              >
                Title
              </th>
              <th
                scope="col"
                className="px-6 py-4 text-sm font-medium text-white"
              >
                Name
              </th>
              <th
                scope="col"
                className="px-6 py-4 text-sm font-medium text-white"
              >
                Payment Type
              </th>
              <th
                scope="col"
                className="px-6 py-4 text-sm font-medium text-white"
              >
                Account Number
              </th>
              <th
                scope="col"
                className="px-6 py-4 text-sm font-medium text-white"
              >
                Account Holder Name
              </th>
              <th
                scope="col"
                className="px-6 py-4 text-sm font-medium text-white"
              >
                Action
              </th>
            </tr>
          </thead>
          <tbody className="font-Acme">
            {paymentList.length === 0 && "No Data found"}
              {
                      
                paymentList.map((item, i)=> {
                  return(
                    <tr className="border-b bg-white">
                    <td className="whitespace-nowrap px-6 py-4 text-sm font-light text-gray-900">
                      {i + 1}
                    </td>
                    <td className="whitespace-nowrap px-6 py-4 text-sm font-light text-gray-900">
                      {item.title}
                    </td>
                    <td className="whitespace-nowrap px-6 py-4 text-sm font-light text-gray-900">
                      {item.name}
                    </td>
                    <td className="whitespace-nowrap px-6 py-4 text-sm font-light text-gray-900">
                      {item.payment_type}
                    </td>
                    <td>{item.acnumber}</td>
                    <td>{item.acholderName}</td>

                    <td className="whitespace-nowrap px-6 py-4 text-sm font-light text-gray-900">
                
                      <button className="bg-primary-red rounded-full p-1 px-2 text-white"
                      onClick={() =>  handleDelete(item.id) }
                      >
                        Delete
                      </button>

                      <button className="bg-primary-red rounded-full p-1 px-2 text-white"
                        data-bs-toggle="modal"
                        data-bs-target="#UpdatePaymentModalDemo"
                        onClick={()=> {
                           setPaymentId(item.id)
                        }}
                      >
                        Edit
                      </button>

                       <UpdatePayment paymentId={paymentId} />

                    </td>
                  </tr>
                  )
                })
              }


          
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ListPayment;
